import { VeritantWordmark } from '@/components/veritant-wordmark';

/**
 * Shown while the stored token is being validated on a cold load — neither portal yet, because
 * which one this is depends on the answer — and while a logout leaves for the IdP's end session.
 * The wordmark alone on the Off White ground, and one thin Sapphire bar moving under it.
 *
 * Plain elements, not the kit's `Skeleton`: the suite counts `[data-slot="skeleton"]` across a
 * page to know it has loaded, and a splash is not a page's loading state.
 */
export function AuthSplash() {
  return (
    // No `status` role: the front door's specs read the page's one status region, and a splash
    // still leaving would make it two.
    <div
      aria-busy="true"
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[var(--color-off-white)]"
    >
      <span className="sr-only">Loading</span>
      <VeritantWordmark tone="sapphire" className="text-4xl" />
      <span className="relative h-0.5 w-40 overflow-hidden rounded-full bg-[var(--veritant-royal-15)]">
        <span className="absolute inset-y-0 left-0 w-1/3 animate-[veritant-splash_1.1s_ease-in-out_infinite] rounded-full bg-[var(--color-sapphire)] motion-reduce:animate-none" />
      </span>
    </div>
  );
}
